import { render, staticRenderFns } from "./cAccordianRetailers.vue?vue&type=template&id=32a47578&"
import script from "./cAccordianRetailers.vue?vue&type=script&lang=js&"
export * from "./cAccordianRetailers.vue?vue&type=script&lang=js&"
import style0 from "./cAccordianRetailers.vue?vue&type=style&index=0&id=32a47578&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports